import React, {useEffect, useState} from "react";
import { Modal, Row, Col } from "antd";

import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderDesingProcessData from "../../components/render-desing-process-data";

import { HeaderOptions } from "./styles";

import moment from 'moment'

// Hooks
import useProcessDesings from "../../hooks/useProcessDesings";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const ModalDesingProcess = ({ visible, handleVisible, article, setLink }) => {
    const [listDesings, setListDesings] = useState(null);
    const [selectedProcessDesing, setSelectedProcessDesing] = useState(null);
    const [selectedRowKey, setSelectedRowKey] = useState([]);

  const handleOk = () => {
    handleVisible(false);
    setLink(selectedProcessDesing.id)
  };

  const handleCancel = () => {
    handleVisible(false);
  };

  const { processDesings } = useProcessDesings();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    if(article) {
        const newList = processDesings.filter(dsg => dsg.articleId === article.id)
        const normalized = newList.map((article, i) => {
            return {
              key: i,
              ...article
            };
          });
      
        normalized && setListDesings(normalized);
        if (normalized && normalized[0]) {
        setSelectedProcessDesing(normalized[0]);
        setSelectedRowKey([normalized[0].key]);
        }
    }
  }, [article, processDesings]);

  const columns = [
    {
        title: t('table.header.name'),
        dataIndex: "desingName",
        key: "desingName",
        sorter: (a, b) => a.desingName.localeCompare(b.desingName),
        defaultSortOrder: "descend",
        ...Search("desingName")
      },
      {
        title: t('table.header.design_date'),
        dataIndex: "date",
        key: "date",
        sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
        ...SearchDates("date"),
        render: date => moment(date).format("DD/MM/YYYY HH:mm:ss")
      },
  ];

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedProcessDesing(processDesings.find(obj => obj.id === record.id));
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
    type: "radio"
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    setSelectedProcessDesing(processDesings.find(obj => obj.id === row.id));
  };

   

  return (
    listDesings && (
      <div>
        <Modal
          title={"Seleciona un diseño"}
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          okText={t('button.modal.link')}
          cancelText={t('button.modal.cancel')}
          width="80vw"
        >
          <Row>
            <Col xl={12} lg={12} md={24}>
                <Table data={listDesings} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
            </Col>
            <Col xl={12} lg={12} md={24}>
                <HeaderOptions>{selectedProcessDesing.desingName}</HeaderOptions>
                <RenderDesingProcessData selectedProcessDesing={selectedProcessDesing} />
            </Col>
          </Row>
        </Modal>
      </div>
    )
  );
};

export default ModalDesingProcess;